import api from '../../api'
import _ from 'lodash'

export default {
  state: () => ({
    products: [],
    gameProducts: [],
    teamProducts: [],
    gameProductsSales: [],
    productsArchived: [],
    productsSales: [],
  }),
  getters: {
    teamProducts: state => state.products,
    allTeamsProducts: state => state.teamProducts,
    teamProductsArchived: state => state.productsArchived,
    gameProducts: state => state.gameProducts || [],
    gameProductsSales: state => state.gameProductsSales || [],
    archivedGroupedTeamProducts: state => state.productsArchived.map(product => ({
      ...product,
      productDetail: state.products.filter(pr => pr.id === product.productId)[0]
    })),
    teamProductsSales: state => state.productsSales,
    productsWithoutCampaign: (state, getters) => {
      return state.products.filter(product =>
        !getters.teamCampaigns.find(campaign => campaign.productId === product.id)
        && !getters.tempCampaigns.find(campaign => campaign.productId === product.id)
      )
    }
  },
  actions: {
    async fetchProducts({ commit, getters }) {
      const team = getters.myTeam
      if (team) {
        try {
          const { data } = await api.product.findAllByTeamId(team.id)
          commit('SET_PRODUCTS', data)
        } catch (e) {
          //this.$toast.error('Something went wrong!');
        }
      }
    },
    async fetchAllGameProducts({commit, getters}) {
      const id = getters.currentGameId;
      if(id){
        try {
          const {data} = await api.product.findAllByGameId(id)

          const groupedCategories = _.groupBy([...data], item => item.productCategoryId)
          const allGameProductsByCuisine = [];
          _.forOwn(groupedCategories, categoryRows => {
            if (categoryRows[0]) {
              allGameProductsByCuisine.push({
                id: categoryRows[0].productCategoryId,
                name: getters.productCategories.find(c => c.id === categoryRows[0].productCategoryId).name,
                results: categoryRows,
              })
            }
          });

          const groupedTeams = _.groupBy([...data], item => item.teamId)
          const allGameProductsByTeams = []
          _.forOwn(groupedTeams, teamRows => {
            if (teamRows[0]) {
              allGameProductsByTeams.push({
                id: teamRows[0].teamId,
                name: getters.gameAllTeams.find(team => team.id === teamRows[0].teamId).name,
                results: teamRows
              })
            }
          })

          commit('SET_GAME_PRODUCTS', allGameProductsByCuisine);
          commit('SET_TEAM_PRODUCTS', allGameProductsByTeams)
        } catch (e) {
          this.$toast.error('Something went wrong!');
        }
      }
    },
    async fetchArchivedProducts({ commit, getters }) {
      const team = getters.myTeam
      if (team) {
        try {
          const { data } = await api.product.findAllArchivedByTeamId(team.id)
          commit('SET_ARCHIVED_PRODUCTS', data)
        } catch (e) {
          //this.$toast.error('Something went wrong!');
        }
      }
    },
    async fetchProductsSales({ commit, getters }) {
      const team = getters.myTeam
      if (team) {
        try {
          const { data } = await api.product.findSoldProductsForTeam(team.id);
          commit('SET_PRODUCTS_SALES', data)
        } catch (e) {
          //this.$toast.error('Something went wrong!');
        }
      }
    },
    async fetchGameProductsSales({commit, getters}) {
      const id = getters.currentGameId;
      if (id) {
        try {
          const {data} = await api.product.findAllSoldProducts(id)
          const grouped = _.groupBy(data, item => item.teamId)
          const allGameSalesByTeam = []
          _.forOwn(grouped, teamRows => {
            if (teamRows[0]) {
              allGameSalesByTeam.push({
                id: teamRows[0].teamId,
                name: getters.gameAllTeams.find(team => team.id === teamRows[0].teamId).name,
                results: teamRows,
              })
            }
          })
          commit('SET_GAME_PRODUCTS_SALES', allGameSalesByTeam)
        } catch (e) {
          this.$toast.error('Something went wrong!');
        }
      }
    },
    async saveProduct({ commit }, product) {
      try {
        /*if(product.quality === 0){
          product.quality = 0.01
          product.cost = 2
        }*/
        const { data } = await api.product.save(product)
        if (product.id) {
          commit('UPDATE_PRODUCT', data)
        } else {
          commit('ADD_PRODUCT', data)
        }
        this.$toast.success(`Product "${data.name}" has been ${product.id ? 'updated' : 'created'}!`);
        return true
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }
      return false
    },
    async deleteProduct({ commit, dispatch }, product) {
      try {
        await api.product.delete(product.id)
        dispatch('deleteCampaigns', product.id)
        commit('DELETE_PRODUCT', product.id)
        this.$toast.success(`Product "${product.name}" has been deleted!`);
        return true
      } catch (e) {
        this.$toast.error('You can´t remove this product beacause you have already promoted it');
      }
      this.$toast.error('You can´t remove this product beacause you have already promoted it');
      return false
    },
    SOCKET_TEAM_PRODUCT_NEW({ commit, getters }, product) {
      if (getters.me.id !== product.lastUserId) {
        commit('ADD_PRODUCT', product)
      }
    },
    SOCKET_TEAM_PRODUCT_UPDATE({ commit, getters }, product) {
      if (getters.me.id !== product.lastUserId) {
        commit('UPDATE_PRODUCT', product)
      }
    },
  },
  mutations: {
    SET_PRODUCTS(state, data) {
      state.products = data || []
    },
    SET_GAME_PRODUCTS(state, data) {
      state.gameProducts = data || []
    },
    SET_TEAM_PRODUCTS(state, data) {
      state.teamProducts = data || []
    },
    SET_ARCHIVED_PRODUCTS(state, data) {
      state.productsArchived = data || []
    },
    SET_PRODUCTS_SALES(state, data) {
      state.productsSales = data || []
    },
    SET_GAME_PRODUCTS_SALES(state, data) {
      state.gameProductsSales = data || []
    },
    ADD_PRODUCT(state, product) {
      state.products.push(product)
    },
    UPDATE_PRODUCT(state, product) {
      state.products = state.products.map(p => {
        if (p.id === product.id) {
          return {
            ...p,
            ...product
          }
        }
        return p
      })
    },
    DELETE_PRODUCT(state, productId) {
      state.products = state.products.filter(p => p.id !== productId)
    }
  },
}
